// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { BoundariesActions, BoundariesActionTypes } from 'actions/boundaries-actions';
import { AuthActionTypes, AuthActions } from 'actions/auth-actions';

import { ObjectsActions, ObjectsActionTypes } from 'actions/objects-action';
import { ObjectsState } from '.';

const defaultState: ObjectsState = {
    fetching: false,
    initialized: false,
    data: null,
    error: null,
};

export default (
    state: ObjectsState = defaultState,
    action: ObjectsActions | BoundariesActions | AuthActions,
): ObjectsState => {
    switch (action.type) {
        case ObjectsActionTypes.GET_OBJECT: {
            return {
                ...state,
                fetching: true,
                initialized: false,
                data: null,
                error: null,
            };
        }
        case ObjectsActionTypes.GET_OBJECT_SUCCESS:
            return {
                ...state,
                initialized: true,
                fetching: false,
                data: action.payload.data,
            };
        case ObjectsActionTypes.GET_OBJECT_FAILED:
            return {
                ...state,
                initialized: true,
                fetching: false,
                error: action.payload.error,
            };
        case BoundariesActionTypes.RESET_AFTER_ERROR:
        case AuthActionTypes.LOGOUT_SUCCESS: {
            return { ...defaultState };
        }
        default:
            return state;
    }
};
